// Triggered when the form is submitted, used only for analytics purpose
//
const onFormSubmitted = function () {
  document.getElementById("bulk-finder-form").addEventListener("turbo:submit-start", function () {
    App.analytics.ga_track("Bulk Email Finder", "Creation")
  })
}

document.addEventListener("turbo:load", function () {
  if (!App.currentPageIs("bulk_finders", "new")) {
    return
  }

  return onFormSubmitted()
})
